//@flow
import * as React from "react";
import styled from "react-emotion";
import WorkItem from "../WorkItem";
import { black } from "../../styles/colors";
import { theme, mqMin } from "../../styles/theme";
import { getSlides, pageProgress } from "../../utilities";
import ScrollNotifier from "../ScrollNotifier";
import NoSSR from "react-no-ssr";
import CirlceIcon from "../CircleIcon";
import includes from "lodash.includes";
import { TimerStack } from "../ImageStack";
const OverScroll =
  typeof document !== "undefined" ? require("react-over-scroll").default : null;

const ProcessGrid = styled.section`
  position: relative;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  padding-top: ${theme.spaceHuge};
  padding-bottom: ${theme.spaceHuge};
  color: ${black};
`;

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${theme.maxWidth3};
  margin-left: auto;
  margin-right: auto;
  ${mqMin(theme.tablet)} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
const WorkContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  height: 100vh;
  justify-content: flex-start;
  align-items: center;
  transform: translateX(${props => `-${props.progress}%`});
  transition: transform 1s cubic-bezier(0.55, 0, 0.1, 1);
`;

const IconWrap = styled.div`
  position: absolute;
  bottom: -${props => props.height / 2}px;
  left: calc(50% - ${props => props.height / 2}px);
  opacity: 0.8;
  transform: rotate(${props => props.rotate}deg);
`;

const getFactor = () => {
  if (typeof window === "undefined") {
    return 1;
  }
  if (window.innerWidth < theme.tablet) {
    return 2;
  }
  return 1;
};

const workEdgeToProps = edge => {
  return {
    text: edge.node.data.work_list_title,
    heading: edge.node.data.client_name,
    meta: edge.node.data.type_of_work,
    uid: `/article/${edge.node.uid}`
  };
};

export const getProgress = (step = 5) => {
  let lastProgress = 0;
  let lastIndex = 0;
  return progress => {
    if (progress < lastProgress - step) {
      lastProgress = progress;
      lastIndex = lastIndex - step;
    }
    if (progress > lastProgress + step) {
      lastProgress = progress;
      lastIndex = lastIndex + step;
    }

    return lastIndex;
  };
};

const rotateProgress = getProgress();

export default ({ workItems }) => {
  const caseStudies = workItems.filter(e =>
    includes(e.node.tags, "Case Study")
  );
  return (
    <NoSSR>
      {console.log(workItems)}
      <ProcessGrid>
        <OverScroll slides={getSlides(6, 3)} factor={getFactor()}>
          {(page, progress) => (
            <div style={{ overflow: "hidden" }}>
              {progress > 0 &&
              progress !== 100 && (
                <IconWrap rotate={rotateProgress(progress)} height={100}>
                  <CirlceIcon text={"SCROLLIN WITH THE HOMMIES"} height={100} />
                </IconWrap>
              )}
              <WorkContainer progress={pageProgress(page, getSlides(6, 3))}>
                {(page === 0 || page === 3) && (
                  <ScrollNotifier offset="0%" onEnter="WORK_ENTER" />
                )}
                {(page === 1 || page === 4) && (
                  <ScrollNotifier offset="0%" onEnter="WORK_1" />
                )}
                {(page === 2 || page === 5) && (
                  <ScrollNotifier offset="0%" onEnter="WORK_2" />
                )}
                <WorkItem
                  text={` We love our clients and we're proud to share our work`}
                  progress={progress}
                  active={page === 0}
                  delay={0}
                />
                <WorkItem
                  {...workEdgeToProps(caseStudies[0])}
                  progress={progress}
                  active={
                    (getSlides(6, 3) === 3 && page === 0) ||
                    (getSlides(6, 3) === 6 && page === 1)
                  }
                  delay={1}
                />
                <WorkItem
                  {...workEdgeToProps(caseStudies[1])}
                  progress={progress}
                  active={
                    (getSlides(6, 3) === 3 && page === 1) ||
                    (getSlides(6, 3) === 6 && page === 2)
                  }
                  delay={2}
                />
                <WorkItem
                  {...workEdgeToProps(caseStudies[2])}
                  progress={progress}
                  active={
                    (getSlides(6, 3) === 3 && page === 1) ||
                    (getSlides(6, 3) === 6 && page === 3)
                  }
                  delay={3}
                />
                <WorkItem
                  {...workEdgeToProps(caseStudies[3])}
                  progress={progress}
                  active={
                    (getSlides(6, 3) === 3 && page === 2) ||
                    (getSlides(6, 3) === 6 && page === 4)
                  }
                  delay={4}
                />
                <ScrollNotifier onLeave="WORK_3" />
                <WorkItem
                  {...workEdgeToProps(caseStudies[4])}
                  progress={progress}
                  active={
                    (getSlides(6, 3) === 3 && page === 2) ||
                    (getSlides(6, 3) === 6 && page === 5)
                  }
                  delay={5}
                />
              </WorkContainer>
            </div>
          )}
        </OverScroll>
      </ProcessGrid>
    </NoSSR>
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkSlider/index.js